import createZipFromObject from "./createZipFromObject";

const zipUpContents = async (contents) => {
    const blob = await createZipFromObject(contents);

    return blob;
}

export default zipUpContents;